import React, { createContext, useContext, useState, ReactNode, useMemo, useCallback } from 'react';
import { IMatterRequestParams } from '../interface/matterRequest';

interface MatterRequestContextType {
  matterRequestParams: IMatterRequestParams | null;
  updateMatterRequestParams: (params: IMatterRequestParams | null) => void;
}

const MatterRequestContext = createContext<MatterRequestContextType | undefined>(undefined);

export const MatterRequestProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [matterRequestParams, setMatterRequestParams] = useState<IMatterRequestParams | null>(null);

  const updateMatterRequestParams = useCallback((params: IMatterRequestParams | null) => {
    setMatterRequestParams(params);
  }, []);
  const matterRequestContextValue = useMemo(
    () => ({
      matterRequestParams,
      updateMatterRequestParams,
    }),
    [matterRequestParams, updateMatterRequestParams],
  );
  return (
    <MatterRequestContext.Provider value={matterRequestContextValue}>
      {children}
    </MatterRequestContext.Provider>
  );
};

export const useMatterRequest = () => {
  const context = useContext(MatterRequestContext);
  if (!context) {
    throw new Error('useMatterRequest must be used within a MatterRequestProvider');
  }
  return context;
};
